// extracted by mini-css-extract-plugin
export default {"style":"styles_style__zCP7V"};